// extracted by mini-css-extract-plugin
export default {"wrapper":"product_wrapper__BTV6o","content-left":"product_content-left__ICAqM","content-right":"product_content-right__qlRdk"};